import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import ProducerNotes from '../../objects/producerNotes/ProducerNotes';
import NotReadyYet from '../../objects/producerNotes/NotReadyYet';
import Image from '../../objects/image/SecondaryImage';
import LibraryImage from '../../objects/image/SecondaryLibraryImage';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appDataActions from '../../../actions/appDataActions';
import * as userDataActions from '../../../actions/userDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import {getAssetComponentByType} from '../../../helpers/componentHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as enviromentHelper from '../../../helpers/environmentHelper';
import * as appConstants from '../../../constants/appConstants';
import * as assetConstants from '../../../constants/assetConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as localStorage from '../../../localStorage/localStorage';
import * as componentConstants from '../../../constants/componentConstants';
import * as imageHelper from '../../../helpers/imageHelper';
import {TweenLite, Elastic, Bounce, Expo, ScrollTo} from 'gsap';
import gsap from 'gsap-react-plugin';
import _ from 'lodash';

class ScrollScreen extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screen: this.props.screen,
            userData: this.props.userData,
            env: enviromentHelper.getEnvironment(),
            is_resource_screen: appHelper.isDefined(this.props.screen.is_resource_screen) && this.props.screen.is_resource_screen,
            locale: {},
            status: objectConstants.STATUS_NOT_STARTED,
            initialStatus: "",
            multiPath: appHelper.isDefined(this.props.screen.multi_path) ? this.props.screen.multi_path : {enabled: false},
            allowReviewMode: true,
            reviewMode: false,
            propsUpdated: false,
            renderedObjects: [],
            updateCharacter: false,
            screenCharacter: {},
            assets: {
                background: {
                    src: "",
                    type: "",
                    type_id: ""
                },
                screenAsset: {
                    src: "",
                    pose: "",
                    position: ""
                },
                character: {
                    src: "",
                    pose: "",
                    position: ""
                },
            },
            parentBackground: {
                src: "",
                type: "",
                type_id: ""
            },
            callbacks: {
                updateCharacterExpression: null,
                onObjectComplete: null,
            },
            currentObjectIndex: 0,
            showProgression: false,
            imageIsTracking: false,
            allowGoToScreen: false,
            goToScreenId: 0,
            terminateScreen: false,
            terminateBite: false,
            producerNotes: appHelper.getScreenNotes(this.props.parentScreen, this.props.screen),
            screenIsReady: this.props.screen.objects.length > 0 && (appHelper.canSeeContent(this.props.screen) || appHelper.isDefined(this.props.parentScreen)),
            allowClippedBlurEffect: appHelper.allowClippedBlurEffect(),
            allowScroll: true,
            hasReceivedFocus: false,
            focusOnNextObject: false,
            scrollHeight: 0,
            imageStyles: imageHelper.checkImageWidth(this.props.screen).styles,
            imageClass: imageHelper.getImageClass(this.props.screen),
            updateImageStyles: false,
            continue_label: appHelper.getLocaleString("continue_label"),
            credit_label: appHelper.getLocaleString("credit_label"),
        };
        this.getLocale = this.getLocale.bind(this);
        this.getObject = this.getObject.bind(this);
        this.getScreenId = this.getScreenId.bind(this);
        this.getBiteId = this.getBiteId.bind(this);
        this.isReviewMode = this.isReviewMode.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getAssetType = this.getAssetType.bind(this);
        this.storeUserResponse = this.storeUserResponse.bind(this);
        this.setCallbacks = this.setCallbacks.bind(this);
        this.updateCharacterExpression = this.updateCharacterExpression.bind(this);
        this.onObjectComplete = this.onObjectComplete.bind(this);
        this.updateScreenResults = _.debounce(this.updateScreenResults.bind(this), 300);
        this.setScreenAccessed = _.debounce(this.setScreenAccessed.bind(this), 300);
        this.showProgressionButton = this.showProgressionButton.bind(this);
        this.navigateToNextScreen = this.navigateToNextScreen.bind(this);
        this.scrollTo = this.scrollTo.bind(this);
        this.onScrollComplete = this.onScrollComplete.bind(this);
        this.onContinueBtnReveled = this.onContinueBtnReveled.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.checkScreenStatus = this.checkScreenStatus.bind(this);
        this.setReviewMode = this.setReviewMode.bind(this);
        this.renderAllObjects = this.renderAllObjects.bind(this);
        this.transitionCharacterExpressions = this.transitionCharacterExpressions.bind(this);
        this.transitionCharacter = this.transitionCharacter.bind(this);
        this.transitionPrevCharacter = this.transitionPrevCharacter.bind(this);
        this.goToScreen = this.goToScreen.bind(this);
        //new
        this.getCharacterName = this.getCharacterName.bind(this);
        this.handleObjectProgression = this.handleObjectProgression.bind(this);
        this.hasNextObject = this.hasNextObject.bind(this);
        this.getLayoutClass = this.getLayoutClass.bind(this);
        this.getScreenStatus = this.getScreenStatus.bind(this);
        this.getSubScreenParent = this.getSubScreenParent.bind(this);
        this.checkIsResourceScreen = this.checkIsResourceScreen.bind(this);
        this.updateResourceObjectResult = this.updateResourceObjectResult.bind(this);
        this.updateResourceScreenResult = this.updateResourceScreenResult.bind(this);
        this.setScreenNotReadyYet = this.setScreenNotReadyYet.bind(this);
        this.setScreenNotReadyYet = this.setScreenNotReadyYet.bind(this);
        this.setCharacterPose = this.setCharacterPose.bind(this);
        this.getFeedClass = this.getFeedClass.bind(this);
        this.getPanelStyle = this.getPanelStyle.bind(this);
        this.getPanelLocation = this.getPanelLocation.bind(this);
        this.scrollToOnComplete = this.scrollToOnComplete.bind(this);
        this.setFocusRecieved = this.setFocusRecieved.bind(this);
        this.focusOnNext = this.focusOnNext.bind(this);
        this.setScrollHeight = this.setScrollHeight.bind(this);
        this.resizeWatcher = this.resizeWatcher.bind(this);
        this.allowInheritParentPanelStyle = this.allowInheritParentPanelStyle.bind(this);
        this.getImageStyles = this.getImageStyles.bind(this);
        this.updateClippedBlur = this.updateClippedBlur.bind(this);
        this.goToMenu = this.goToMenu.bind(this);
        this.handleContinue = this.handleContinue.bind(this);
    }

    componentDidMount() {
        window.addEventListener("resize", this.resizeWatcher);
        if (this.props.audio.audioRef.length > 0) {
            this.props.actions.clearAudio();
        }
        this.setScreenAccessed();
        this.props.biteCallbacks.showHeader(true);
        this.setCallbacks();
        this.getLocale();
        if (this.state.screenIsReady) {
            this.getObject(this.state.currentObjectIndex);
        } else {
            this.setScreenNotReadyYet();
        }
        this.getAssets();
        this.checkScreenStatus();
        this.getImageStyles();
    }

    componentWillReceiveProps(nextProps) {
        let screenUserData = {};

        if (this.state.is_resource_screen) {
            screenUserData = userDataHelper.getResourceScreenUserData(nextProps.userData, this.state.screen.screen_id);
        } else if (this.props.parentScreen) {
            screenUserData = userDataHelper.getSubScreenUserData(nextProps.userData, this.props.parentScreen.screen_id, this.state.screen.screen_id);

        } else {
            screenUserData = userDataHelper.getScreenUserData(nextProps.userData, this.state.screen.screen_id);
        }
        this.setState({userData: Object.assign({}, nextProps.userData)});

        if (this.state.status !== screenUserData.status && screenUserData.status === objectConstants.STATUS_COMPLETE) {
            this.setState({
                status: screenUserData.status,
            });
            if (!appHelper.isDefined(this.props.parentScreen)) {
                this.props.actions.setScreenTitle(appHelper.getLocalData(this.state.screen).title);
            }
        }

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screen),
                continue_label: appHelper.getLocaleString("continue_label"),
                credit_label: appHelper.getLocaleString("credit_label"),
            });
            if (!appHelper.isDefined(this.props.parentScreen)) {
                this.props.actions.setScreenTitle(appHelper.getLocalData(this.state.screen).title);
            }
        }

        this.setState({updateImageStyles: true});
    }

    componentDidUpdate() {
        let setScrollHeight = this.setScrollHeight;
        setTimeout(function () {
            setScrollHeight();
        }, 500);
        if (this.state.propsUpdated && this.state.reviewMode && this.state.allowReviewMode) {
            this.setReviewMode();
        }

        if (this.state.updateCharacter) {

            this.transitionCharacterExpressions();
        }

        if (this.state.focusOnNextObject) {
            this.focusOnNext();
        }

        if (this.state.updateImageStyles) {
            this.getImageStyles();
        }
    }

    componentWillUnmount() {
        this.props.actions.clearAudio();
        window.removeEventListener("resize", this.resizeWatcher);
    }

    setScreenAccessed(){
        this.props.actions.setScreenAccessed(this.state.screen, this.props.parentScreen);
    }

    getImageStyles() {
        this.setState({
            updateImageStyles: false,
            imageStyles: Object.assign({}, imageHelper.checkImageWidth(this.state.screen)).styles,
            imageClass: imageHelper.getImageClass(this.state.screen),
        });
    }

    resizeWatcher(){
        let scrollContainer = this.refs[`${this.state.screen.screen_id}_feedContainer`];
        if (appHelper.isDefined(scrollContainer)) {
            let scrollHeight = scrollContainer.scrollHeight;
            this.setState({scrollHeight: scrollHeight});
        }
    }


    setScreenNotReadyYet() {
        let completionData = {
            screen_status: objectConstants.STATUS_COMPLETE,
            sub_screen_complete: appHelper.isDefined(this.props.parentScreen) ? true : undefined
        };

        this.showProgressionButton();

        this.updateScreenResults(completionData);
    }

    checkScreenStatus() {
        let screenUserData = {};
        if (this.state.is_resource_screen) {
            screenUserData = userDataHelper.getResourceScreenUserData(this.state.userData, this.state.screen.screen_id);
        } else if (this.props.parentScreen) {
            screenUserData = userDataHelper.getSubScreenUserData(this.state.userData, this.props.parentScreen.screen_id, this.state.screen.screen_id);

        } else {
            screenUserData = userDataHelper.getScreenUserData(this.state.userData, this.state.screen.screen_id);
        }

        if (this.state.status !== screenUserData.status && screenUserData.status === objectConstants.STATUS_COMPLETE) {
            this.setState({
                status: screenUserData.status,
            });
        }

        this.setState({
            initialStatus: this.state.initialStatus.length === 0 ? screenUserData.status : this.state.initialStatus
        });
        /* let screenStatus = getScreenUserData(this.props.userData, this.props.screen.screen_id).status;
         let reviewMode = screenStatus === objectConstants.STATUS_COMPLETE && localStorage.post_completion_mode === appConstants.POST_COMPLETION_MODE_REVIEW;
        // console.log(`reviewMode: ${this.state.reviewMode} - line 120`);
         this.setState({status: screenStatus, checkCompletionStatus: true, reviewMode: reviewMode, propsUpdated: true});
         */
    }

    setCallbacks() {
        //console.log(`reviewMode: ${this.state.reviewMode} - line 125`);
        this.setState({
            callbacks: Object.assign({}, this.state.biteCallbacks, {
                updateCharacterExpression: this.updateCharacterExpression,
                onObjectComplete: this.onObjectComplete,
                getScreenId: this.getScreenId,
                getBiteId: this.getBiteId,
                storeUserResponse: this.storeUserResponse,
                scrollTo: this.scrollTo,
                isReviewMode: this.isReviewMode,
                getCharacterName: this.getCharacterName,
                hasNextObject: this.hasNextObject,
                navigateToNextScreen: this.navigateToNextScreen,
                getScreenStatus: this.getScreenStatus,
                getSubScreenParent: this.getSubScreenParent,
                checkIsResourceScreen: this.checkIsResourceScreen,
                goToScreen: this.goToScreen,
                resizeWatcher: this.resizeWatcher
            })
        });
    }

    getSubScreenParent() {
        return appHelper.isDefined(this.props.parentScreen) ? this.props.parentScreen : undefined;
    }

    getLocale() {
        let locale = appHelper.getLocalData(this.state.screen);
        this.setState({locale: Object.assign({}, locale)});
        //if (!appHelper.isDefined(this.props.parentScreen) && !this.state.is_resource_screen) {
        if (!appHelper.isDefined(this.props.parentScreen) && !this.state.is_resource_screen) {
            this.props.actions.setScreenTitle(locale.title);
        }
    }

    getScreenId() {
        return this.state.screen.screen_id;
    }

    getBiteId() {

        return this.props.biteCallbacks.getBiteId();
    }

    isReviewMode() {
        return this.state.reviewMode;
    }

    getCharacterName() {
        return this.state.locale.character_name;
    }

    getScreenStatus() {
        return this.state.status;
    }

    checkIsResourceScreen() {
        return this.state.is_resource_screen;
    }

    setReviewMode() {

        let objectsToRender = appHelper.getRenderableObjects(this.props.userData, this.getBiteId(), this.state.screen.objects);
        this.setState(
            {
                screen: Object.assign({}, this.state.screen, {
                    objects: Object.assign([], objectsToRender)
                }),
                propsUpdated: false
            }
        );
        this.renderAllObjects(objectsToRender);
    }

    renderAllObjects(objectsToRender) {
        let renderableObjects = [];
        for (let i = 0; i < objectsToRender.length; i++) {
            let object = objectsToRender[i];
            let objectType = Object.assign({}, getAssetComponentByType(object.asset_type_code),
                {
                    data: object
                }
            );
            renderableObjects = dataHelper.immutablePush(renderableObjects, objectType);
        }
        this.setState({renderedObjects: Object.assign([], renderableObjects), showProgression: true});
    }

    getObject(index) {
        let object = this.state.screen.objects[index];
        let objectType = Object.assign({}, getAssetComponentByType(object.asset_type_code),
            {
                data: object
            }
        );
        //console.log(objectType);
        //let objectLocale = appHelper.getLocalData(object.locale);
        //this.props.actions.setScreenTitle(objectLocale.title);
        this.setState({
            renderedObjects: Object.assign([], dataHelper.immutablePush(this.state.renderedObjects, objectType)),
            focusOnNextObject: this.state.hasReceivedFocus
        });
    }

    getAssets() {
        let backgroundAsset = Object.assign(this.state.assets.background);
        let hasLeftAsset = appHelper.isDefined(this.state.screen.assets.left);
        let hasRightAsset = appHelper.isDefined(this.state.screen.assets.right);
        let screenAsset = {};
        let screenCharacter = {};
        let characterAsset = Object.assign(this.state.assets.character);
        let parentBackground= Object.assign(this.state.parentBackground);

        if (hasLeftAsset) {
            screenAsset = this.getAssetType(this.state.screen.assets.left);
        } else if (hasRightAsset) {
            screenAsset = this.getAssetType(this.state.screen.assets.right);

        }
        if (appHelper.isDefined(this.state.screen.assets.background)) {
            backgroundAsset = appHelper.getBackgroundAsset(this.state.screen.assets.background);
        }

        if (appHelper.isDefined(this.state.screen.assets.character)) {
            screenCharacter = appHelper.getCharacterAsset(this.state.screen.assets.character);
            characterAsset = appHelper.getCharacterPose(screenCharacter, this.state.screen.assets.character);
        }

        if (appHelper.isDefined(this.props.parentScreen) && appHelper.isDefined(this.props.parentScreen.assets.background)) {
            parentBackground = appHelper.getBackgroundAsset(this.props.parentScreen.assets.background);
        }
        this.setState({
            screenCharacter: Object.assign({}, screenCharacter),
            assets: Object.assign({}, this.state.assets, {
                background: backgroundAsset,
                screenAsset: screenAsset,
                character: characterAsset,
            }),
            parentBackground:  Object.assign({}, parentBackground)
        });
    }

    getAssetType(asset) {

        let returnAsset = {};
        if (asset.constant === assetConstants.ASSET_TYPE_ID_CHARACTER) {
            let screenCharacter = appHelper.getCharacterAsset(asset);
            returnAsset = appHelper.getCharacterPose(screenCharacter, asset);
        } else if (asset.constant === assetConstants.ASSET_TYPE_ICON) {
            returnAsset = appHelper.getIconAsset(asset);
        } else if (asset.constant === assetConstants.ASSET_TYPE_IMAGE) {
            returnAsset = appHelper.getImageAsset(asset);
        } else if (asset.constant === assetConstants.ASSET_TYPE_LIBRARY_IMAGE) {
            returnAsset = appHelper.getLibraryImageAsset(asset);
        }
        returnAsset = appHelper.isDefined(returnAsset.locale) ? appHelper.getLocalData(returnAsset) : returnAsset;

        if(appHelper.isDefined(asset.constant) && !appHelper.isDefined(returnAsset.type)){
            returnAsset = Object.assign({},returnAsset,{
                type: asset.constant
            });
        }
        return returnAsset;
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    updateCharacterExpression(pose) {
        /*if (appHelper.isDefined(pose) && pose.pose !== objectConstants.INHERIT) {
            let characterAsset = appHelper.getCharacterPose(this.state.screenCharacter, pose);
            if (appHelper.isDefined(characterAsset.src) && characterAsset.src.length > 0) {
                let characterRef = this.refs.character;
                characterRef.removeAttribute("style");
                TweenLite.set(characterRef, {opacity: 0, '-webkit-filter': 'blur(5px)', 'filter': 'blur(5px)'});

                if (appHelper.isDefined(this.refs.prevCharacter)) {
                    let prevCharacterRef = this.refs.prevCharacter;
                    prevCharacterRef.removeAttribute("style");
                    TweenLite.set(prevCharacterRef, {opacity: 1, '-webkit-filter': 'blur(0px)', 'filter': 'blur(0px)'});
                }

                //if (characterAsset.src !== this.state.assets.character.src) {
                this.setState({
                    assets: Object.assign({}, this.state.assets, {
                        character: characterAsset,
                        prevCharacter: this.state.assets.character,

                    }),
                    updateCharacter: true
                });
            }
        }*/
        //}
    }

    transitionCharacterExpressions() {
        this.setState({updateCharacter: false});
        this.transitionPrevCharacter();
        this.transitionCharacter();

    }

    transitionCharacter() {
        let characterRef = this.refs.character;

        TweenLite.to(characterRef, 0.6, {
            opacity: 1,
            filter: 'blur(0px)',
            ease: Expo.easeOut
        });
    }

    transitionPrevCharacter() {
        let characterRef = this.refs.prevCharacter;

        TweenLite.to(characterRef, 2, {
            opacity: 0,

            filter: 'blur(10px)',
            ease: Expo.easeOut
        });
    }

    storeUserResponse(responseObj) {
        let params = Object.assign({}, responseObj, {
            userData: this.props.userData,
            bite_id: this.getBiteId(),
            parent_screen_id: appHelper.isDefined(this.props.parentScreen) ? this.props.parentScreen.screen_id : undefined,
            screen_id: this.getScreenId(),

        });

        this.props.actions.storeUserResponse(params).then((userData) => {
            this.props.actions.setSuspendData(userData);
        }).catch(error => {
        });
    }


    navigateToNextScreen() {
        let goToMenu = this.goToMenu;
        if (appHelper.isDefined(this.props.parentScreen)) {
            if (appHelper.isDefined(this.props.closeDialog)) {
                this.props.closeDialog();
            }
            if (this.state.allowGoToScreen && !isNaN(parseInt(this.state.goToScreenId)) && appHelper.screenExists(this.state.goToScreenId)) {
                this.goToScreen(this.state.goToScreenId);
            } else if (this.state.terminateScreen) {
                let nextScreenId = appHelper.getNextScreenId(this.props.parentScreen.screen_id);
                if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
                    setTimeout(() => {
                        goToMenu();
                    }, 500);
                } else {
                    this.props.actions.setNextLessonLocation(nextScreenId);
                }
            } else if (this.state.terminateBite) {
                if (localStorage.bites.length > 1) {
                    setTimeout(() => {
                        goToMenu();
                    }, 500);
                } else {
                    let bite = appHelper.getBiteById(this.props.biteCallbacks.getBiteId());
                    this.goToScreen(bite.screens[0].screen_id);
                }
            } else {
                let hasNextSubScreen = this.props.biteCallbacks.hasNextSubScreen(this.state.screen);
                if (hasNextSubScreen) {
                    this.props.biteCallbacks.goToNextSubScreen(this.state.screen);
                } else {
                    let nextScreenId = appHelper.getNextScreenId(this.props.parentScreen.screen_id);
                    if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
                        if(appHelper.isDefined(this.props.parentScreen.progression) && (this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_OPEN || this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_EXPLORE_INTERESTS) && appHelper.isDefined(this.props.closeDialog)){
                            return false;
                        }else {
                            setTimeout(() => {
                                goToMenu();
                            }, 500);
                        }
                    } else {
                        if(appHelper.isDefined(this.props.parentScreen.progression) && (this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_OPEN || this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_EXPLORE_INTERESTS) && appHelper.isDefined(this.props.closeDialog)){
                            return false;
                        }else {
                            let goToScreen = this.goToScreen;
                            setTimeout(() => {
                                goToScreen(nextScreenId);
                            }, 500);
                        }
                    }
                }
            }
        } else {
            if (this.state.allowGoToScreen && !isNaN(parseInt(this.state.goToScreenId)) && appHelper.screenExists(this.state.goToScreenId)) {
                this.goToScreen(this.state.goToScreenId);
            } else if (this.state.terminateBite) {
                if (localStorage.bites.length > 1) {
                    setTimeout(() => {
                        goToMenu();
                    }, 500);
                } else {
                    let bite = appHelper.getBiteById(this.props.biteCallbacks.getBiteId());
                    this.goToScreen(bite.screens[0].screen_id);
                }
            } else {
                let nextScreenId = appHelper.getNextScreenId(this.getScreenId());
                if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
                    setTimeout(() => {
                        goToMenu();
                    }, 500);
                } else {
                    this.goToScreen(nextScreenId);
                }
            }
        }
    }

    goToMenu(){
        this.context.router.push('menu');
    }

    goToScreen(goTo) {
        this.props.actions.setNewLessonLocation(goTo);

    }

    handleObjectProgression() {

    }

    handleContinue(completionData){
        let currentIndex  = appHelper.getArrayObjectIndexByKey(this.state.screen.objects,"asset_id",completionData.asset_id);
        if (currentIndex < (this.state.screen.objects.length - 1)) {

            let newIndex = currentIndex + 1;

            this.setState({currentObjectIndex: newIndex});
            this.getObject(newIndex);
            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
                //this.updateScreenResults(objectConstants.STATUS_IN_PROGRESS, asset_id, response);
            } else {
                // this.updateScreenResults(objectConstants.STATUS_COMPLETE, asset_id, response);
            }
            completionData = Object.assign({}, completionData, {
                screen_status: this.state.status !== objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_IN_PROGRESS : objectConstants.STATUS_COMPLETE
            });
            if (this.state.is_resource_screen) {
                //save resource object tracking
                this.updateResourceObjectResult(completionData);
            } else {

                this.updateScreenResults(completionData);
            }
        } else {
            this.setState({
                allowScroll: appHelper.AllowAutoProgressionIfLast(completionData.asset_type_code)
            });
            if (this.state.is_resource_screen) {
                //Last object of resource screen we can add logic here when we need to
                this.updateResourceObjectResult(completionData);

            } else if (appHelper.isDefined(this.props.parentScreen)) {
                //////////////////////
                //COMPLETE SUB SCREEN
                //////////////////////

                if (!completionData.navigateToNextScreen && (!appHelper.isDefined(completionData.showProgressionButton) || (appHelper.isDefined(completionData.showProgressionButton) && completionData.showProgressionButton))) {
                    this.showProgressionButton();
                }

                completionData = Object.assign({}, completionData, {
                    screen_status: objectConstants.STATUS_COMPLETE,
                    sub_screen_complete: true
                });

                this.updateScreenResults(completionData);

                //this.props.biteCallbacks.onSubScreenComplete(this.state.screen);

            } else {

                if (!completionData.navigateToNextScreen && (!appHelper.isDefined(completionData.showProgressionButton) || (appHelper.isDefined(completionData.showProgressionButton) && completionData.showProgressionButton))) {
                    this.showProgressionButton();
                }

                completionData = Object.assign({}, completionData, {
                    screen_status: objectConstants.STATUS_COMPLETE,
                    allowScroll: appHelper.AllowAutoProgressionIfLast(completionData.asset_type_code)
                });

                this.updateScreenResults(completionData);
                //////////////////////
                //COMPLETE SCREEN
                /////////////////////
                //console.log(`complete screen`);
            }
        }
    }

    onObjectComplete(completionData) {
        if (completionData.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE || completionData.progression === objectConstants.OBJECT_PROGRESSION_AUTO) {
            this.handleContinue(completionData);
        } else if (completionData.progression === objectConstants.OBJECT_PROGRESSION_GO_TO) {

            if (completionData.progressionType === objectConstants.GO_TO_TYPE_OBJECT) {
                let nextObjectIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.objects, "asset_id", completionData.progressionGoToId);
                this.setState({currentObjectIndex: nextObjectIndex});
                this.getObject(nextObjectIndex);
                this.updateScreenResults(completionData);
            } else if (completionData.progressionType === objectConstants.GO_TO_TYPE_SCREEN && appHelper.screenExists(completionData.progressionGoToId)) {

                this.setState({
                    allowGoToScreen: true,
                    goToScreenId: completionData.progressionGoToId,
                    allowScroll: appHelper.AllowAutoProgressionIfLast(completionData.asset_type_code)
                 });

                if (appHelper.isDefined(this.props.parentScreen)) {

                    this.props.biteCallbacks.completeScreen();
                    //////////////////////
                    //COMPLETE SUB SCREEN
                    /////////////////////
                    if (!completionData.navigateToNextScreen || (completionData.navigateToNextScreen && this.state.initialStatus === objectConstants.STATUS_COMPLETE)) {
                        this.showProgressionButton();
                    }
                    completionData = Object.assign({}, completionData, {
                        screen_status: objectConstants.STATUS_COMPLETE,
                        sub_screen_complete: true
                    });

                    this.updateScreenResults(completionData);


                } else {
                    if (!completionData.navigateToNextScreen || (completionData.navigateToNextScreen && this.state.initialStatus === objectConstants.STATUS_COMPLETE)) {
                        this.showProgressionButton();
                    }
                    completionData = Object.assign({}, completionData, {
                        screen_status: objectConstants.STATUS_COMPLETE
                    });
                    this.updateScreenResults(completionData);
                    //////////////////////
                    //COMPLETE SCREEN
                    /////////////////////
                    //console.log(`complete screen`);
                }
            }else{
                this.handleContinue(completionData);
            }

        } else if (completionData.progression === objectConstants.OBJECT_PROGRESSION_TERMINAL) {
            if (completionData.progressionType === objectConstants.TERMINAL_TYPE_SCREEN) {
                this.setState({
                    terminateScreen: true,
                    allowScroll: appHelper.AllowAutoProgressionIfLast(completionData.asset_type_code)
                });


                if (appHelper.isDefined(this.props.parentScreen)) {
                    //////////////////////
                    //COMPLETE SUB SCREEN
                    /////////////////////
                    this.props.biteCallbacks.completeScreen();

                    if (!completionData.navigateToNextScreen) {
                        this.showProgressionButton();
                    }
                    completionData = Object.assign({}, completionData, {
                        screen_status: objectConstants.STATUS_COMPLETE,
                        sub_screen_complete: true
                    });

                    this.updateScreenResults(completionData);


                } else {
                    if (!completionData.navigateToNextScreen) {
                        this.showProgressionButton();
                    }
                    completionData = Object.assign({}, completionData, {
                        screen_status: objectConstants.STATUS_COMPLETE
                    });
                    this.updateScreenResults(completionData);
                    //////////////////////
                    //COMPLETE SCREEN
                    /////////////////////
                    //console.log(`complete screen`);
                }
            } else if (completionData.progressionType === objectConstants.TERMINAL_TYPE_BITE) {
                this.setState({
                    terminateBite: true,
                    allowScroll: appHelper.AllowAutoProgressionIfLast(completionData.asset_type_code)
                });

                let bite = appHelper.getBiteById(this.props.biteCallbacks.getBiteId());
                this.props.actions.terminateBite(bite).then((userData) => {

                    if (!completionData.navigateToNextScreen) {
                        this.showProgressionButton();
                    }

                    if (appHelper.isDefined(this.props.parentScreen)) {
                        this.props.biteCallbacks.completeScreen();
                    }

                    completionData = Object.assign({}, completionData, {
                        screen_status: objectConstants.STATUS_COMPLETE
                    });

                    this.updateScreenResults(completionData);

                }).catch(error => {
                });
            }
        }
    }

    updateScreenResults(completionData) {
        let params = Object.assign({}, completionData, {
            bite_id: this.getBiteId(),
            parent_screen_id: appHelper.isDefined(this.props.parentScreen) ? this.props.parentScreen.screen_id : undefined,
            screen_id: this.getScreenId(),
            object_status: completionData.status,
            object_result: {}
        });
        this.props.actions.updateScreenResults(params).then((userData) => {
            if (appHelper.isDefined(completionData.sub_screen_complete) && completionData.sub_screen_complete && appHelper.isDefined(this.props.biteCallbacks.onSubScreenComplete)) {
                try {
                    this.props.biteCallbacks.onSubScreenComplete(this.state.screen);
                } catch (err) {
                    //  console.log('error',err);
                }
            }
            this.props.actions.setSuspendData(userData).then((trackingData) => {
                if (completionData.screen_status === objectConstants.STATUS_COMPLETE) {
                    this.props.actions.setScreenComplete(this.state.screen, this.props.parentScreen);
                }

                if((completionData.navigateToNextScreen && this.state.initialStatus !== objectConstants.STATUS_COMPLETE) && this.state.allowGoToScreen){
                    this.navigateToNextScreen();
                }
                /*let objectIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.objects,"asset_id",completionData.asset_id);
                if (completionData.screen_status === objectConstants.STATUS_COMPLETE  && objectIndex === this.state.screen.objects.length - 1) {
                    if (appHelper.AllowAutoProgressionIfLast(completionData.asset_type_code)) {
                        if (this.state.initialStatus !== objectConstants.STATUS_COMPLETE && !appHelper.isDefined(this.props.closeDialog)){
                            this.navigateToNextScreen();
                        } else {
                            if (!completionData.navigateToNextScreen){
                                this.showProgressionButton();
                            }
                        }
                    }
                }*/

            }).catch(error => {
            });
        }).catch(error => {
        });
    }

    updateResourceObjectResult(completionData) {
        let params = Object.assign({}, completionData, {
            screen_id: this.getScreenId(),
            object_status: completionData.status,

        });
        this.props.actions.updateResourceObjectResult(params).then((userData) => {
            this.props.actions.setSuspendData(userData).then((trackingData) => {
                let resourceScreen = appHelper.getArrayObjectByKey(userData.resources, "screen_id", this.state.screen.screen_id);
                if (resourceScreen.status === objectConstants.STATUS_COMPLETE) {
                    if (completionData.screen_status === objectConstants.STATUS_COMPLETE) {
                        this.props.actions.setScreenComplete(this.state.screen);
                    }
                }
            }).catch(error => {
            });
        }).catch(error => {
        });
    }

    updateResourceScreenResult(completionData) {
        let params = Object.assign({}, completionData, {
            screen_id: this.getScreenId(),
            object_status: completionData.status,
            screen_status: objectConstants.STATUS_COMPLETE
        });
        this.props.actions.updateResourceScreenResult(params).then((userData) => {
            this.props.actions.setSuspendData(userData).then((trackingData) => {
                if (completionData.screen_status === objectConstants.STATUS_COMPLETE) {
                    this.props.actions.setScreenComplete(this.state.screen);
                }
            }).catch(error => {
            });
        }).catch(error => {
        });
    }

    showProgressionButton() {
        let nextScreenId = appHelper.getNextScreenId(this.state.screen.screen_id);
        //if (nextScreenId.length > 0) {
        this.setState({showProgression: true});

        //}
    }

    scrollTo(pos,allow) {
        if (this.state.status !== objectConstants.STATUS_COMPLETE || (appHelper.isDefined(allow) && allow)) {
            let feed = this.refs[`${this.state.screen.screen_id}_feed`];
            if(feed.scrollTop < pos) {
                TweenLite.to(feed, objectConstants.SCROLL_SPEED, {
                    scrollTop: pos,
                    ease: Expo.easeInOut,
                }).eventCallback("onComplete", this.onScrollComplete);
            }
        }
    }

    onContinueBtnReveled() {
        this.scrollToTop();
    }

    scrollToTop() {
        if (this.state.initialStatus !== objectConstants.STATUS_COMPLETE && this.state.allowScroll) {
            let anchor = this.refs[`${this.state.screen.screen_id}_bottom_anchor`];
            let scrollToOnComplete = this.scrollToOnComplete;
            setTimeout(function () {
                scrollToOnComplete(anchor.offsetTop);

            }, 1000);
        }
    }

    scrollToOnComplete(pos) {
        let feed = this.refs[`${this.state.screen.screen_id}_feed`];
        if(feed.scrollTop < pos) {
            TweenLite.to(feed, objectConstants.SCROLL_SPEED, {
                scrollTop: pos,
                ease: Expo.easeInOut,
            }).eventCallback("onComplete", this.onScrollComplete);
        }

    }


    onScrollComplete() {

    }

    hasNextObject(objectIndex) {
        //let objectIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.objects, "asset_id", object.asset_id);
        return objectIndex < (this.state.screen.objects.length - 1);
    }

    getLayoutClass() {
        if (appHelper.isDefined(this.state.screen.assets.left) && this.state.screenIsReady) {
            return 'left-asset-screen';
        } else if (appHelper.isDefined(this.state.screen.assets.right) && this.state.screenIsReady) {
            return 'right-asset-screen';
        } else {
            return 'full-screen';
        }
    }

    setCharacterPose(object) {

        let characterAsset = {};
        if (appHelper.isDefined(object.character_pose) && object.character_pose.pose !== objectConstants.INHERIT) {
            characterAsset = appHelper.getCharacterPose(this.state.screenCharacter, object.character_pose);
        }

        return characterAsset;
    }

    getFeedClass() {
        return this.state.allowClippedBlurEffect ? 'blurred-feed' : 'standard-feed';
    }

    getPanelStyle() {
        if(!appHelper.isDefined(this.props.parentScreen)) {
            return appHelper.isDefined(this.state.screen.panel_style) ? this.state.screen.panel_style : "frosted_white";
        }else{
            return this.props.parentScreen.screen_type === componentConstants.SCREEN_TYPE_TABBED
            &&
            (this.props.parentScreen.tab_type === objectConstants.TAB_TYPE_HORIZONTAL_FRAMELESS || this.props.parentScreen.tab_type === objectConstants.TAB_TYPE_VERTICAL_FRAMELESS)
            &&
            appHelper.isDefined(this.props.parentScreen.panel_style)
                ? this.props.parentScreen.panel_style
                : "";
        }
    }

    getPanelLocation() {
        return appHelper.isDefined(this.state.screen.panel_location) ? this.state.screen.panel_location : objectConstants.PANEL_LOCATION_CENTERED;
    }

    setFocusRecieved() {
        this.setState({hasReceivedFocus: true});
    }

    focusOnNext() {
        this.setState({focusOnNextObject: false});
        let object = this.state.renderedObjects[this.state.renderedObjects.length - 1];
        let focusEl = document.getElementById(`object_${object.data.asset_id}`);
        focusEl.focus();
    }

    setScrollHeight(){
        let lastObjectData = this.state.renderedObjects[this.state.renderedObjects.length - 1];
        let overwrite = false;
        if(appHelper.isDefined(lastObjectData)) {
            let lastObject = document.getElementById(`object_${lastObjectData.data.asset_id}`);
            let feed = this.refs[`${this.state.screen.screen_id}_feed`];
            let scrollContainer = this.refs[`${this.state.screen.screen_id}_feedContainer`];
            if (appHelper.isDefined(scrollContainer)) {
                let scrollHeight = scrollContainer.scrollHeight;
                let objectEndPos = lastObject.offsetTop + lastObject.offsetHeight;
                //let difference = feed.offsetHeight - lastObject.offsetHeight;
                let endPosIntoFeed = Math.round(objectEndPos / feed.offsetHeight);
                let scrollHeightIntoFeed = Math.round(scrollHeight / feed.offsetHeight);

                if(scrollHeightIntoFeed > endPosIntoFeed){
                    overwrite = true;
                    scrollHeight = feed.offsetHeight * endPosIntoFeed;

                }
                if (scrollHeight > this.state.scrollHeight || overwrite) {
                    this.setState({scrollHeight: scrollHeight});
                }
            }
        }
    }
    allowInheritParentPanelStyle() {
        return appHelper.isDefined(this.props.parentScreen)
            &&
            this.props.parentScreen.screen_type === componentConstants.SCREEN_TYPE_TABBED
            &&
            (this.props.parentScreen.tab_type === objectConstants.TAB_TYPE_HORIZONTAL_FRAMELESS || this.props.parentScreen.tab_type === objectConstants.TAB_TYPE_VERTICAL_FRAMELESS)
            &&
            appHelper.isDefined(this.props.parentScreen.panel_style);
    }

    updateClippedBlur(){
        let contentArea = document.getElementById(`screenWrapper`);
        let width = this.state.imageStyles.width + 48;
        let maxWidth = (contentArea.offsetWidth / 100) * 40;

        if(width > maxWidth){
            width = maxWidth;
        }

        if(imageHelper.showAssetLeftPanel(this.state.screen)){
            return {clipPath: `inset( 0px  0px 0px ${width}px)`, mozClipPath: `inset( 0px 0px 0px ${width}px)`};
        }else if(imageHelper.showAssetRightPanel(this.state.screen)) {
            return {clipPath: `inset( 0px  ${width}px 0px 0px)`, mozClipPath: `inset( 0px ${width}px 0px 0px)`};
        }else{
            return {};
        }
    }

    render() {
        return (
            <div className="content-screen">
                <div className="background-container">
                    {
                        !appHelper.isDefined(this.props.parentScreen) && !this.state.is_resource_screen
                            ?
                            <img src={this.getImagePath(this.state.assets.background.src)} alt=""/>
                            :
                            null
                    }
                </div>
                <div className="screen-container">
                    <div className={`content-wrapper ${this.getPanelStyle()} ${this.getPanelLocation()} ${imageHelper.getScreenAssetPanelWidth(this.state.screen)}`}>
                        {
                            !appHelper.isDefined(this.props.parentScreen) && this.state.allowClippedBlurEffect
                                ?
                                <div className={`content-wrapper-background `} style={this.updateClippedBlur()}>
                                    <img className="blur" src={this.getImagePath(this.state.assets.background.src)}
                                         alt=""/>
                                </div>
                                :
                                null
                        }
                        {
                            this.allowInheritParentPanelStyle() && this.state.allowClippedBlurEffect
                                ?
                                <div className={`content-wrapper-background `}>
                                    <img className="blur" src={this.getImagePath(this.state.parentBackground.src)} alt=""/>
                                </div>
                                :
                                null
                        }
                        {
                            appHelper.isDefined(this.state.screen.panel_location) && this.state.screen.panel_location === objectConstants.PANEL_LOCATION_RIGHT && appHelper.isDefined(this.state.screen.assets.left) && appHelper.isDefined(this.state.assets.screenAsset) && this.state.assets.screenAsset.src.length > 0 && this.state.screenIsReady
                                ?
                                <div className="asset-left-panel">

                                        {this.state.assets.screenAsset.type === assetConstants.ASSET_TYPE_IMAGE
                                            ?
                                            <Image screenObject={this.state.screen.assets.left}  id={imageHelper.getAssetLeftPanelId(this.state.screen.screen_id)}/>
                                            :
                                            <div className={`asset-image-wrapper ${this.state.imageClass}`} style={this.state.imageStyles}>
                                                <img src={this.getImagePath(this.state.assets.screenAsset.src)} id={imageHelper.getAssetLeftPanelId(this.state.screen.screen_id)} alt=""/>
                                            </div>
                                        }

                                    {appHelper.isDefined(this.state.assets.screenAsset.credit) && this.state.assets.screenAsset.credit.length > 0 &&
                                        <div className={`image-credit`}  style={this.state.imageStyles}>{this.state.credit_label}: {this.state.assets.screenAsset.credit}</div>
                                    }

                                </div>
                                :
                                null
                        }


                        <div className={`content-area ${this.getFeedClass()}`} id={`${this.state.screen.screen_id}_feed_id`} ref={`${this.state.screen.screen_id}_feed`}>
                            {
                                appHelper.isDefined(this.state.screen.assets.left) && appHelper.isDefined(this.state.assets.screenAsset) && this.state.assets.screenAsset.src.length > 0 && this.state.screenIsReady
                                    ?
                                    <div className="asset-col-left">

                                        {this.state.assets.screenAsset.type === assetConstants.ASSET_TYPE_IMAGE
                                            ?
                                            <Image screenObject={this.state.screen.assets.left} id={imageHelper.getAssetLeftId(this.state.screen.screen_id)} />
                                            :
                                            <div className={`asset-image-wrapper ${this.state.imageClass}`} style={this.state.imageStyles}>
                                                <img src={this.getImagePath(this.state.assets.screenAsset.src)} alt="" id={imageHelper.getAssetLeftId(this.state.screen.screen_id)}/>
                                            </div>
                                        }

                                        {appHelper.isDefined(this.state.assets.screenAsset.credit) && this.state.assets.screenAsset.credit.length > 0 &&
                                            <div className={`image-credit`}  style={this.state.imageStyles}>{this.state.credit_label}: {this.state.assets.screenAsset.credit}</div>
                                        }

                                    </div>
                                    :
                                    null
                            }
                            <div className={`${this.getLayoutClass()} `} role="feed">
                                <div className="feed-container" ref={`${this.state.screen.screen_id}_feedContainer`}
                                     style={{minHeight: `${this.state.scrollHeight}px`}}>


                                    {
                                        this.state.producerNotes.length > 0
                                            ?
                                            <ProducerNotes notes={this.state.producerNotes}
                                                           screen_id={this.state.screen.screen_id}/>
                                            :
                                            null
                                    }

                                    {
                                        this.state.screenIsReady && this.state.renderedObjects.length > 0
                                            ?
                                            this.state.renderedObjects.map((object,index )=>
                                                <div className="feed-object-container" key={index}
                                                     role="article" tabIndex="0" id={`object_${object.data.asset_id}`}
                                                     onFocus={this.setFocusRecieved}>
                                                    <object.component screenObject={object.data}
                                                                      callbacks={this.state.callbacks}
                                                                      characterPose={this.setCharacterPose(object.data)}
                                                                      index={appHelper.getArrayObjectIndexByKey(this.state.screen.objects,"asset_id",object.data.asset_id)}
                                                    />
                                                </div>
                                            )
                                            :
                                            null
                                    }

                                    {
                                        !this.state.screenIsReady
                                            ?
                                            <NotReadyYet screen_id={this.state.screen.screen_id}/>
                                            :
                                            null
                                    }
                                    {this.state.showProgression
                                        ? <Button ref={`${this.state.screen.screen_id}_button`}
                                                  label={this.state.continue_label}
                                                  id={`${this.state.screen.screen_id}_button`}
                                                  onClick={this.navigateToNextScreen}
                                                  onRevealed={this.onContinueBtnReveled}
                                        />
                                        : null
                                    }

                                    <div ref={`${this.state.screen.screen_id}_bottom_anchor`}/>
                                </div>
                            </div>
                            {
                                appHelper.isDefined(this.state.screen.assets.right) && appHelper.isDefined(this.state.assets.screenAsset) && this.state.assets.screenAsset.src.length > 0 && this.state.screenIsReady
                                    ?
                                    <div className="asset-col-right">
                                        {this.state.assets.screenAsset.type === assetConstants.ASSET_TYPE_IMAGE
                                            ?
                                            <Image screenObject={this.state.screen.assets.right} id={imageHelper.getAssetRightId(this.state.screen.screen_id)}/>
                                            :
                                            <div className={`asset-image-wrapper ${this.state.imageClass}`} style={this.state.imageStyles}>
                                                <img src={this.getImagePath(this.state.assets.screenAsset.src)} id={imageHelper.getAssetRightId(this.state.screen.screen_id)} alt=""/>
                                            </div>
                                        }

                                        {appHelper.isDefined(this.state.assets.screenAsset.credit) && this.state.assets.screenAsset.credit.length > 0 &&
                                            <div className={`image-credit`}  style={this.state.imageStyles}>{this.state.credit_label}: {this.state.assets.screenAsset.credit}</div>
                                        }

                                    </div>
                                    :
                                    null
                            }
                        </div>
                        {
                            appHelper.isDefined(this.state.screen.panel_location) && this.state.screen.panel_location === objectConstants.PANEL_LOCATION_LEFT && appHelper.isDefined(this.state.screen.assets.right) && appHelper.isDefined(this.state.assets.screenAsset) && this.state.assets.screenAsset.src.length > 0 && this.state.screenIsReady
                                ?
                                <div className="asset-right-panel">

                                        {this.state.assets.screenAsset.type === assetConstants.ASSET_TYPE_IMAGE
                                            ?
                                            <Image screenObject={this.state.screen.assets.right} id={imageHelper.getAssetRightPanelId(this.state.screen.screen_id)}/>
                                            :
                                            <div className={`asset-image-wrapper ${this.state.imageClass}`} style={this.state.imageStyles}>
                                                <img src={this.getImagePath(this.state.assets.screenAsset.src)} alt="" id={imageHelper.getAssetRightPanelId(this.state.screen.screen_id)}/>
                                            </div>
                                        }

                                        {appHelper.isDefined(this.state.assets.screenAsset.credit) && this.state.assets.screenAsset.credit.length > 0 &&
                                            <div className={`image-credit`}  style={this.state.imageStyles}>{this.state.credit_label}: {this.state.assets.screenAsset.credit}</div>
                                        }

                                </div>
                                :
                                null
                        }
                    </div>
                </div>
            </div>
        );
    }
}

ScrollScreen.propTypes = {
    screen: PropTypes.object.isRequired,
    biteCallbacks: PropTypes.object.isRequired,
    parentScreen: PropTypes.object,
    contentData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    audio: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    closeDialog: PropTypes.func
};

ScrollScreen.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData,
        audio: state.audio
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ScrollScreen);



/** WEBPACK FOOTER **
 ** ./src/components/screens/scrollScreen/ScrollScreen.js
 **/